import React, { Component } from "react";
import "./index.css";
import { withRouter } from "react-router-dom";
import debounce from "lodash.debounce";
import { GetProductDetails } from "../../../../services";
import { encryptId } from "../../../../../utils/crypto";

class Bestofferbanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productId: "",
      productSuggestions: [],
      error: null,
    };

    this.suggestionsBoxRef = React.createRef();
    this.debouncedFetchSuggestions = debounce(this.fetchSuggestions, 300);
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleInputChange = (event) => {
    const value = event.target.value;

    // ✅ Allow only English letters, numbers and spaces
    const validRegex = /^[A-Za-z0-9 ]*$/;

    if (!validRegex.test(value)) {
      this.setState({
        error: "Only English letters and numbers are allowed.",
      });

      return;
    }

    this.setState({
      productId: value,
      error: "",
    });

    if (value.length > 2) {
      this.debouncedFetchSuggestions(value);
    } else {
      this.setState({ productSuggestions: [] });
    }
  };

  fetchSuggestions = async (q) => {
    try {
      const res = await GetProductDetails.getAllProductQuerySearchList(q);
      if (res && res.products) {
        // Remove duplicates based on product id
        const uniqueProducts = res.products.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.id === value.id),
        );

        this.setState({ productSuggestions: uniqueProducts, error: null });
      } else {
        this.setState({ productSuggestions: [], error: "No products found." });
      }
    } catch (error) {
      console.error(error);
      this.setState({ error: "Search failed.", productSuggestions: [] });
    }
  };

  handleSuggestionClick = (product) => {
    this.setState({ productId: product.name, productSuggestions: [] });
    const encId = encryptId(product.id);
    this.props.history.push(`/p/${encId}`);
  };

 handleSearch = (event) => {
  event.preventDefault();

  const { productId } = this.state;

  const trimmedValue = productId.trim();

  // ✅ Only English letters + numbers + spaces
  const validRegex = /^[A-Za-z0-9 ]+$/;

  // ✅ Empty check
  if (!trimmedValue) {
    this.setState({
      error: "Please enter search text.",
    });
    return;
  }

  // ✅ Minimum 3 characters
  if (trimmedValue.length < 3) {
    this.setState({
      error: "Minimum 3 letters are required to search.",
    });
    return;
  }

  // ✅ Invalid characters check
  if (!validRegex.test(trimmedValue)) {
    this.setState({
      error: "Only English letters and numbers are allowed.",
    });
    return;
  }

  // ✅ Clear errors
  this.setState({ error: "" });

  // ✅ Navigate
  this.props.history.push(`/tagsearch/${trimmedValue}`);
};

  handleClickOutside = (event) => {
    if (
      this.suggestionsBoxRef.current &&
      !this.suggestionsBoxRef.current.contains(event.target)
    ) {
      this.setState({ productSuggestions: [] });
    }
  };

  render() {
    const { productId, productSuggestions, error } = this.state;

    return (
      <div>
        <div className="section145">
          <div className="text-center">
            <img src="/img/banner.jpg" className="backbanner" alt="banner" />

            <div className="search-container" style={{ position: "relative" }}>
              <form onSubmit={this.handleSearch} className="search-form">
                <input
                  type="text"
                  placeholder="Search with Product Name, Category & Tag"
                  className="search-box"
                  value={productId}
                  onChange={this.handleInputChange}
                  autoComplete="off"
                  style={{
                    border: error ? "2px solid red" : "",
                  }}
                />
                <button type="submit" className="search-btn">
                  Search
                </button>
              </form>

              {productSuggestions.length > 0 && (
                <div className="suggestions-box" ref={this.suggestionsBoxRef}>
                  {productSuggestions.map((product) => (
                    <div
                      key={product.id}
                      className="suggestion-item"
                      onClick={() => this.handleSuggestionClick(product)}
                    >
                      <img
                        src={product.photo}
                        alt={product.name}
                        className="suggestion-img"
                        crossOrigin="anonymous"
                      />
                      <div className="suggestion-content">
                        <h4>{product.name}</h4>
                        <p>{product.sortDesc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {error && (
              <p
                className="error-message"
                style={{
                  color: "red",
                  marginTop: "6px",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                {error}
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Bestofferbanner);
